import React, {FC, memo} from "react";
import './GridAreaContentLayoutTextField.css'
import classnames from "classnames";

const GridAreaContentTextFieldComponent: FC<{
  label: string,
  value: string | undefined,
  setValue: (value: string) => void,
  disabled?: boolean,
}> = ({
  label,
  value,
  setValue,
  disabled,

}) => {

  return (
    <div className={"grid-area-content-layout-text-field-wrapper"}>
      <label className={classnames("grid-area-content-layout-text-field-label", { "disabled": disabled })}>{label}</label>
      <input
        className={classnames("grid-area-content-layout-text-field", { "disabled": disabled })}
        type="text"
        value={value}
        onChange={e => setValue(e.target.value)}
        disabled={disabled}
        required
      ></input>
    </div>
  )
}


export const GridAreaContentLayoutTextField = memo(GridAreaContentTextFieldComponent)